import { useMemo } from 'react';

import { searchApi } from 'apis/search';

import type { UserPresence } from '../../../presence/reducers/presence';
import type {
  DispatchProps,
  StateProps,
} from '../containers/transferToAgentModal';

import TransferToAgentModal from './transferToAgentModal';

type TransferToAgentModalWrapperProps = StateProps & DispatchProps;

export function TransferToAgentModalWrapper(
  props: TransferToAgentModalWrapperProps,
): JSX.Element {
  const { queueId, onlinePresence, ...restProps } = props;

  const { queueAgents, isLoading: isLoadingQueueAgents } =
    searchApi.useReadSearchUsersQuery(
      {
        filters: {
          strategy: 'all',
          filters: [
            {
              field: 'queues',
              operator: 'includes_one',
              values: [{ value: queueId ?? '' }],
            },
          ],
        },
        sortBy: { field: 'display_name', order: 'asc' },
        pageSize: 1000,
      },
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          queueAgents: data?.data.results.map(({ result }) => result) ?? [],
        }),
        skip: !queueId,
      },
    );

  const filteredPresence = useMemo<UserPresence[]>(() => {
    if (!queueId) {
      return onlinePresence;
    }

    if (!queueAgents.length) {
      return [];
    }

    const queueAgentIds = new Set(queueAgents.map((agent) => agent.id));

    return onlinePresence.filter((presenceUser) =>
      queueAgentIds.has(presenceUser.user.id),
    );
  }, [queueId, queueAgents, onlinePresence]);

  return (
    <TransferToAgentModal
      {...restProps}
      queueId={queueId}
      onlinePresence={filteredPresence}
      isLoadingQueueAgents={isLoadingQueueAgents && !!queueId}
    />
  );
}
